<div class="patient-header">
  <div class="patient-info">
    <div class="avatar">
      <span class="avatar-initial">{{ getPatientInitial() }}</span>
    </div>
    <div class="patient-name-section">
      <span class="patient-name">{{ getFullName() }},</span>
      <span class="patient-details" *ngIf="patient?.age">
        {{ patient.age
        }}<ng-container *ngIf="getGenderKey(patient.gender)"
          >, {{ getGenderKey(patient.gender) | translate }}</ng-container
        >
      </span>
      <span class="pid-badge">
        PID: {{ patient?.bsnNumber || patient?.recordId || "-" }}
      </span>
    </div>
  </div>

  <div class="actions-container d-flex align-items-center gap-2">
    <button class="back-btn" *ngIf="showBackButton" (click)="onBackClick()">
      <i class="fa-solid fa-arrow-left"></i>
      {{ "back" | translate }}
    </button>

    <button
      class="btn btn-sm btn-primary fw-bold"
      *ngIf="showNewWoundButton"
      (click)="onNewWoundClick()"
    >
      <i class="fa-solid fa-plus me-1"></i>
      {{ "addWound" | translate }}
    </button>

    <button
      class="btn btn-sm btn-primary fw-bold"
      *ngIf="showNewWoundButton"
      (click)="onNoWoundClick()"
    >
      {{ "score" | translate }}
    </button>

    <button
      class="btn btn-sm btn-primary fw-bold"
      *ngIf="showFollowUpButton"
      (click)="onNewFollowUpClick()"
    >
      <i class="fa-solid fa-plus me-1"></i>
      {{ "newFollowUp" | translate }}
    </button>
  </div>

  <!-- Scores Section -->
  <div class="score-fields" *ngIf="latestAssessment">
    <div
      class="score-item"
      *ngFor="let risk of latestAssessment.woundAssessmentRiskCategories"
    >
      <span class="score-label">{{
        getDisplayAssessmentCode(risk.assessmentTemplateCode)
      }}</span>
      <div class="score-value-container">
        <span class="score-value">{{ risk.totalScore }}</span>
      </div>
      <!-- Detail Dropdown -->
      <div class="score-detail-dropdown">
        <div class="dropdown-header">
          <span class="risk-name">{{ getDisplayedRiskName(risk) }}</span>
          <span class="risk-score" *ngIf="!isGlassRisk(risk)"
            >{{ "score" | translate }}: {{ risk.totalScore }}</span
          >
          <span class="risk-score" *ngIf="isGlassRisk(risk) && risk.totalScore"
            >Stage: {{ risk.totalScore }}</span
          >
        </div>
        <div class="dropdown-body">
          <div class="follow-up-panel" *ngIf="isWifiRisk(risk)">
            <div class="follow-up-label">
              {{ getWifiStageText(risk) }}
            </div>
            <div class="follow-up-value">
              {{ getWifiRiskLevelText(risk) }}
            </div>
            <div class="follow-up-value">
              {{
                "patientCreate.woundAssessment.wifi.majorAmputationRate"
                  | translate
              }}: {{ getWifiMajorAmputationRate(risk) }}
            </div>
            <div class="follow-up-value" *ngIf="getWifiBreakdown(risk) as breakdown">
              {{
                "patientCreate.woundAssessment.wifi.components" | translate
              }}:
              W-{{ breakdown.wound }} / I-{{ breakdown.ischemia }} / FI-{{
                breakdown.footInfection
              }}
            </div>
          </div>

          <div class="follow-up-panel" *ngIf="isGlassRisk(risk)">
            <div class="follow-up-label">
              {{ "patientCreate.woundAssessment.glass.summary.recommendation" | translate }}
            </div>
            <div class="follow-up-value">
              {{ getGlassRecommendationLabel(risk) }}
            </div>
          </div>

          <div class="follow-up-panel" *ngIf="isIWGDFRisk(risk)">
            <div class="follow-up-label">
              {{
                "patientCreate.woundAssessment.iwgdfFollowUp.label" | translate
              }}
            </div>
            <div class="follow-up-value">
              {{ getIWGDFFollowUpText(risk) }}
            </div>
          </div>

          <div
            class="assessment-question"
            *ngFor="let q of getQuestionsForRisk(risk.assessmentTemplateId)"
          >
            <div class="question-name">
              {{ getDisplayAssessmentName(q.assessmentTemplateName) }}
            </div>
            <div class="answers-list">
              <div
                class="answer-item"
                *ngFor="let ans of q.woundAssessmentAnswers"
              >
                <span class="q-text">{{ getDisplayQuestionText(ans.questionText) }}</span>
                <span class="a-text">{{ getDisplayAnswerText(ans.answerText) }}</span>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</div>
